import { AuditEventType, AuditTrailFilters } from '../../../../../backend/src/auditTrail/auditTrail.types';
import {
  FilterField,
  ServerSideFilterPopover as GenericServerSideFilterPopover,
} from '@/new/components/server-side-filter-popover';

interface AuditTrailFilterPopoverProps {
  filters: AuditTrailFilters;
  onFiltersChange: (filters: AuditTrailFilters) => void;
  clearAllFilters: () => void;
}

const filterFields: FilterField[] = [
  {
    type: 'select',
    key: 'auditEventType',
    label: 'Audit Event',
    placeholder: 'Select event type...',
    options: [
      // Matter events
      { value: AuditEventType.MatterCreate, label: 'Created Matter' },
      { value: AuditEventType.MatterEdit, label: 'Edited Matter' },
      { value: AuditEventType.MatterDelete, label: 'Deleted Matter' },
      { value: AuditEventType.MatterAddUsers, label: 'Added User to Matter' },
      { value: AuditEventType.MatterRemoveUsers, label: 'Removed User from Matter' },
      // Subset events
      { value: AuditEventType.SubsetCreate, label: 'Created Subset' },
      { value: AuditEventType.SubsetEdit, label: 'Edited Subset' },
      { value: AuditEventType.SubsetDelete, label: 'Deleted Subset' },
      // Run events
      { value: AuditEventType.RunCreate, label: 'Created Run' },
      // Document events
      { value: AuditEventType.DocumentUpload, label: 'Uploaded Documents' },
      { value: AuditEventType.DocumentDelete, label: 'Deleted Document' },
      // Relativity events
      { value: AuditEventType.RelativitySync, label: 'Synced Relativity Metadata' },
      {
        value: AuditEventType.RelativityBuildParentChildRelationships,
        label: 'Built Relativity Parent/Child Relationships',
      },
      // Fact events
      { value: AuditEventType.FactCreate, label: 'Created Fact' },
      { value: AuditEventType.FactUpdate, label: 'Updated Fact' },
      { value: AuditEventType.FactBulkUpdate, label: 'Bulk Updated Facts' },
      { value: AuditEventType.FactDelete, label: 'Archived Fact' },
      { value: AuditEventType.FactBulkDelete, label: 'Bulk Deleted Facts' },
      // Chronology events
      { value: AuditEventType.ChronologyCreate, label: 'Created Chronology' },
      { value: AuditEventType.ChronologyEdit, label: 'Edited Chronology' },
      { value: AuditEventType.ChronologyDelete, label: 'Deleted Chronology' },
      { value: AuditEventType.ChronologyAddFact, label: 'Added Fact to Chronology' },
      { value: AuditEventType.ChronologyVerifyFact, label: 'Verified Fact in Chronology' },
      { value: AuditEventType.ChronologyRemoveFact, label: 'Removed Fact from Chronology' },
      // Doc Chronology events
      { value: AuditEventType.DocChronologyCreate, label: 'Created Doc Chronology' },
      { value: AuditEventType.DocChronologyEdit, label: 'Edited Doc Chronology' },
      { value: AuditEventType.DocChronologyDelete, label: 'Deleted Doc Chronology' },
      { value: AuditEventType.DocChronologyAddDocument, label: 'Added Document to Doc Chronology' },
      { value: AuditEventType.DocChronologyRemoveDocument, label: 'Removed Document from Doc Chronology' },
      { value: AuditEventType.DocChronologyAddDocs, label: 'Added Docs to Doc Chronology' },
      // Comment events
      { value: AuditEventType.CommentAdd, label: 'Added Comment' },
      { value: AuditEventType.CommentUpdate, label: 'Updated Comment' },
      { value: AuditEventType.CommentDelete, label: 'Deleted Comment' },
      // Realtime events
      { value: AuditEventType.RealtimeUse, label: 'Started Realtime Session' },
      // Kim Thread events
      { value: AuditEventType.ThreadCreate, label: 'Created Kim Thread' },
      { value: AuditEventType.ThreadDelete, label: 'Deleted Kim Thread' },
      // Inconsistency events
      { value: AuditEventType.InconsistencyDelete, label: 'Deleted Inconsistency' },
      // Inconsistency Report events
      { value: AuditEventType.InconsistencyReportCreate, label: 'Created Inconsistency Report' },
      { value: AuditEventType.InconsistencyReportDelete, label: 'Deleted Inconsistency Report' },
    ],
  },
  {
    type: 'dateRange',
    startKey: 'startDate',
    endKey: 'endDate',
    label: 'Event Date Range',
  },
];

export function AuditTrailFilterPopover({ filters, onFiltersChange, clearAllFilters }: AuditTrailFilterPopoverProps) {
  return (
    <GenericServerSideFilterPopover
      filters={filters}
      onFiltersChange={onFiltersChange}
      clearAllFilters={clearAllFilters}
      fields={filterFields}
    />
  );
}
